export default __webpack_public_path__ + "static/media/sign-in-background.e72c8bb3.png";